export const BASE_URL =
  process.env.REACT_APP_CITIZEN_API_URL || "https://api.citizen.ewama.k42.dev/v1";

export const USER_URL = "/owners";
export const POST_LOGIN_URL = "/owners/login";
export const POST_REGISTER_URL = "/owners/register";
export const UPDATE_PASSWORD_URL = "/owners/password";
export const GET_WHOAMI = "/owners/whoami";
export const GET_REFRESHED_TOKEN = "/owners/refreshToken";
export const GET_SEPARATION_DATA_URL = "/locations";
export const GET_WASTE_DETAIL_DATA_URL = "/wastes";
export const GET_CONTAINER_COLLECTIONS_URL = "/containers";
export const POST_RESRET_PASSWORD_URL = "/owners/passwordReset";
export const POST_UPDATE_PASSWORD_URL = "/owners/passwordUpdate";
export const WASTE_COLLECTION_CALENDAR_URL = "/waste-collection-calendar-citizen";
export const NOTIFICATIONS_TOKEN_URL = "/owners/device";
export const GET_COLLECTION_YARDS_VISITS_SUMMARY_URL = "/collection-yards/visits/summary";
export const GET_COLLECTION_YARD_VISITS_URL = "/collection-yards/visits";
export const GET_COLLECTION_YARD_QR_CODE_URL = "/collection-yards/qr/png";
export const GET_COLLECTION_YARD_VISIT_RECEIPT_URL = "/collection-yards/visit";
export const GET_BILLING_PAYMENTS_URL = "/billing/payments";
